import { render, staticRenderFns } from "./RowCountPill.vue?vue&type=template&id=d5820f2c&scoped=true&"
import script from "./RowCountPill.vue?vue&type=script&lang=js&"
export * from "./RowCountPill.vue?vue&type=script&lang=js&"
import style0 from "./RowCountPill.vue?vue&type=style&index=0&id=d5820f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5820f2c",
  null
  
)

export default component.exports